// extracted by mini-css-extract-plugin
export var csatScore = "_fh-5";
export var header = "_fh-1";
export var panelWrapper = "_fh-2";
export var postPreview = "_fh-3";
export var rightContent = "_fh-0";
export var wrappingText = "_fh-4";